import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { EventType, MessagePosition } from "../../Types";
import { TutorialScene } from "./TutorialScene";
import { BoardContainer } from "../board-scene/BoardContainer";
import { Card } from "../board-scene/cards/Card";
import { Utils } from "../../utils/Utils";
import { GameManager } from "../../GameManager";

export class TutorialManager {

    public static showingSpecialCardDescription: boolean;

    public static init(): void {
    
        GameVars.allowedMoves = null;
        GameVars.gameOver = false;
        GameVars.victory = false;
        GameVars.paused = false;
        GameVars.f = 0;

        GameVars.tutorialStepData = {
            step: 0,
            action: null,
            from: null,
            allowedMoves: null,
            message: null,
            messagePosition: null,
            delay: null,
            t: null
        };

        GameVars.allowedMoves = CardCrawl.Utils.NO_MOVES;
        GameVars.cardCrawlEngine = null;

        GameVars.eventsDispatcher.addEventListener(EventType.CARD_PICKED, TutorialManager.onCardPickedListener, TutorialManager);
        GameVars.eventsDispatcher.addEventListener(EventType.CARD_DROPPED, TutorialManager.onCardDroppedListener, TutorialManager);
        GameVars.eventsDispatcher.addEventListener(EventType.MULLIGAN, TutorialManager.onMuilliganListener, TutorialManager);
        GameVars.eventsDispatcher.addEventListener(EventType.CARD_DEALT, TutorialManager.onCardDealtListener, TutorialManager);
        GameVars.eventsDispatcher.addEventListener(EventType.SHOW_CARD_DESCRIPTION, TutorialManager.showCardDescriptionListener, TutorialManager);
        GameVars.eventsDispatcher.addEventListener(EventType.HIDE_MESSAGE, TutorialManager.hideMessageListener, TutorialManager);

        TutorialManager.showingSpecialCardDescription = false;

        TutorialManager.processStep();
    }

    public static update(): void {
        
        GameVars.f ++;
    }

    public static onCardPickedListener(args: any[]): void {

        const card = args[0] as Card;

        GameVars.allowedMoves = GameVars.tutorialStepData.allowedMoves;

        if (GameVars.allowedMoves !== null) {
            BoardContainer.currentInstance.showAllowedMoves(card.cardData);
        }
    }

    public static onCardDroppedListener(args: any[]): void {

        const [id, item, i] = args;

        const card = CardCrawl.Utils.getCardDataById(id, GameVars.cardCrawlEngine.getState());

        if (item === CardCrawl.TableauType.SHOP) {
            GameVars.cardCrawlEngine.processAction({type: CardCrawl.ActionType.SELL_CARD, card: card, data: null});
        } else {
            GameVars.cardCrawlEngine.processAction({type: CardCrawl.ActionType.MOVE_TO_TABLEAU, card: card, data: {tableau: item, i: i}});
        }
    }

    public static onCardDealtListener(args: any[]): void {

        TutorialScene.currentInstance.onCardDealt();
    }

    public static onMuilliganListener(args: any[]): void {

        if (GameVars.tutorialStepData.step !== 13) {
            return;
        }

        GameVars.cardCrawlEngine.processAction({type: CardCrawl.ActionType.MULLIGAN, card: null, data: null});
    }

    public static processStep(): void {

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        switch (GameVars.tutorialStepData.step + 1) {

            case 1:

                GameVars.tutorialStepData = {
                    step: 1,
                    action: EventType.CLICK,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_1[lan],
                    messagePosition: MessagePosition.MIDDLE,
                    delay: 2000,
                    t: Date.now()
                };

                break;

            case 2:

                GameVars.tutorialStepData = {
                    step: 2,
                    action: EventType.CLICK,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_2[lan],
                    messagePosition: MessagePosition.MIDDLE,
                    delay: 750,
                    t: Date.now()
                };

                break;

            case 3:

                GameVars.tutorialStepData = {
                    step: 3,
                    action: EventType.CLICK,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_3[lan],
                    messagePosition: MessagePosition.BOTTOM,
                    delay: 750,
                    t: Date.now()
                };

                GameVars.cardCrawlEngine = new CardCrawl.Engine(null);

                GameVars.cardCrawlEngine.addEventListener(CardCrawl.EventType.ACTION_PROCESSED, TutorialManager.onActionProcessedListener, TutorialManager);
                GameVars.cardCrawlEngine.init(GameVars.gameData.specialCards, null, GameConstants.TUTORIAL_DECK, Math.floor(Math.random() * 1e4)); 
        
                break;

            case 4:

                GameVars.tutorialStepData = {
                    step: 4,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 0},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [true, false, false, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_4[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };

                break;

            case 5:

                GameVars.tutorialStepData = {
                    step: 5,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 1},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [false, false, true, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_5[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                    
                break;

            case 6:

                GameVars.tutorialStepData = {
                    step: 6,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 3},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [false, false, false, true], chest: false},
                    message: text.TUTORIAL_MESSAGE_6[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                    
                break;

            case 7:

                GameVars.tutorialStepData = {
                    step: 7,
                    action: EventType.CLICK,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_7[lan],
                    messagePosition: MessagePosition.BOTTOM,
                    delay: 1250,
                    t: Date.now()
                };
                
                break;

            case 8:

                GameVars.cardCrawlEngine.setState(GameConstants.TUTORIAL_FORCED_STEP_8);
                TutorialScene.currentInstance.onActionProcessed();

                GameVars.tutorialStepData = {
                    step: 8,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.LOWER, i: 0},
                    allowedMoves: {upperTableau: [true, false, false, false], lowerTableau: [false, false, false, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_8[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                    
                break;

            case 9:

                GameVars.tutorialStepData = {
                    step: 9,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 1},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [false, false, true, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_9[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                    
                break;

            case 10:

                GameVars.tutorialStepData = {
                    step: 10,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.LOWER, i: 3},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [false, false, true, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_10[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                    
                break;

            case 11:

                GameVars.tutorialStepData = {
                    step: 11,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 2},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [true, false, false, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_11[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;
            
            case 12:

                GameVars.tutorialStepData = {
                    step: 12,
                    action: EventType.CLICK,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_12[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };

                break;

            case 13:

                GameVars.cardCrawlEngine.setState(GameConstants.TUTORIAL_FORCED_STEP_13);
                TutorialScene.currentInstance.onActionProcessed();

                GameVars.tutorialStepData = {
                    step: 13,
                    action: EventType.MULLIGAN,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_13[lan],
                    messagePosition: MessagePosition.BOTTOM,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 14:

                GameVars.tutorialStepData = {
                    step: 14,
                    action: EventType.CLICK,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_14[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 15:

                GameVars.tutorialStepData = {
                    step: 15,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 0},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [false, false, false, false], chest: true},
                    message: text.TUTORIAL_MESSAGE_15[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 16:

                GameVars.tutorialStepData = {
                    step: 16,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 1},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [false, false, false, false], chest: true},
                    message: null,
                    messagePosition: null,
                    delay: null,
                    t: Date.now()
                };
                
                break;
            
            case 17:

                GameVars.tutorialStepData = {
                    step: 17,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 3},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [false, false, false, false], chest: true},
                    message: text.TUTORIAL_MESSAGE_17[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 18:

                GameVars.tutorialStepData = {
                    step: 18,
                    action: EventType.SHOW_CARD_DESCRIPTION,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 2},
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_18[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 19:

                GameVars.tutorialStepData = {
                    step: 19,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.UPPER, i: 2},
                    allowedMoves: {upperTableau: [false, false, false, false], lowerTableau: [true, false, false, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_19[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 20:

                GameVars.tutorialStepData = {
                    step: 20,
                    action: EventType.CARD_DROPPED,
                    from: {tableau: CardCrawl.TableauType.LOWER, i: 0},
                    allowedMoves: {upperTableau: [true, false, false, false], lowerTableau: [false, false, false, false], chest: false},
                    message: text.TUTORIAL_MESSAGE_20[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 21:

                GameVars.tutorialStepData = {
                    step: 21,
                    action: EventType.CLICK,
                    from: null,
                    allowedMoves: null,
                    message: text.TUTORIAL_MESSAGE_21[lan],
                    messagePosition: MessagePosition.TOP,
                    delay: 750,
                    t: Date.now()
                };
                
                break;

            case 22:

                GameManager.enterBoardScene();
                break;

            default:
        }

        GameVars.paused = true;

        setTimeout(() => {
            GameVars.paused = false;
        },  GameVars.tutorialStepData.delay);

        TutorialScene.currentInstance.processStep();
    }

    private static showCardDescriptionListener(): void {

        const msg = Utils.getSpecialCardDescription(CardCrawl.CardType.FLAIL);

        TutorialManager.showingSpecialCardDescription = true;

        TutorialScene.currentInstance.showMessageLayer(msg, MessagePosition.TOP, 250, GameVars.tutorialStepData.action);
    }

    private static hideMessageListener(args: any[]): void {
            
        TutorialScene.currentInstance.hideMessageLayer();

        if (GameVars.tutorialStepData.step === 18 && TutorialManager.showingSpecialCardDescription) {

            TutorialManager.showingSpecialCardDescription = false;

            TutorialManager.processStep();
        }
    }

    private static onActionProcessedListener(): void {

        if (GameVars.tutorialStepData.step === 6) {
            GameVars.cardCrawlEngine.setState(GameConstants.TUTORIAL_FORCED_STEP_6);
        }

        if (GameVars.tutorialStepData.step === 11) {
            GameVars.cardCrawlEngine.setState(GameConstants.TUTORIAL_FORCED_STEP_11);
        }

        if (GameVars.tutorialStepData.step === 13) {
            GameVars.cardCrawlEngine.setState(GameConstants.TUTORIAL_FORCED_STEP_14);
        }

        TutorialScene.currentInstance.onActionProcessed();

        if (GameVars.tutorialStepData.action === EventType.CARD_DROPPED || GameVars.tutorialStepData.step === 13) {

            TutorialManager.processStep();
        }
    }
}
